import { CodeInput, CodeInputProps } from './CodeInput';
import { FormField, FormFieldPropsWithoutChildren } from './FormField';

export type FormCodeInputProps = CodeInputProps & FormFieldPropsWithoutChildren;

export function FormCodeInput({
  label,
  helpText,
  error,
  isRequired,
  labelActions,
  inputActions,
  ...rest
}: FormCodeInputProps) {
  return (
    <FormField
      label={label}
      helpText={helpText}
      error={error}
      isRequired={isRequired}
      labelActions={labelActions}
      inputActions={inputActions}
    >
      <CodeInput {...rest} />
    </FormField>
  );
}
